module.exports = __webpack_public_path__ + "static/media/main-promo-3.f160185e.jpg";